import {gql} from '@apollo/client';

export const GET_SORTER_PLAN_LISTING = gql`
    query GetSorterPlanListing($filters: SorterPlanFiltersInput, $pageRequest: SorterPlanPageRequestInput) {
        getSorterPlanListing(filters: $filters, pageRequest: $pageRequest) {
            content {
                id
                sorterId
                warehouseId
                sorterPlanName
                status
                version
                isDropBag
                isSpecified
                sorterType
                isChange
                createdAt
                createdBy
                updatedAt
                updatedBy
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface SorterPlanPageRequestInput {
    page: number;
    size: number;
    sortBy?: string;
    sortDirection?: string;
}

export interface SorterPlanFiltersInput {
    sorterPlanName?: string;
    status?: number;
    sorterId?: number;
    sorterIds?: number[];
    warehouseId?: number;
    sorterType?: number;
}

